/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { dAdd, dDiv, dFix, dMul } from '@/data/Settings-Server';
export { dAdd, dDiv, dFix, dMul };
